/**
 * Amasty Multiple Wishlist compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

import PropTypes from 'prop-types';

import { ProductType } from 'Type/ProductList.type';

export const WishlistItemType = PropTypes.shape({
    id: PropTypes.number,
    sku: PropTypes.string,
    description: PropTypes.string,
    qty: PropTypes.number,
    product: ProductType,
});

export const ItemType = PropTypes.shape({
    wishlistId: PropTypes.number,
    name: PropTypes.string,
    sharingCode: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),
    viewUrl: PropTypes.string,
    activeTab: PropTypes.number,
    isDeleteable: PropTypes.bool,
});

export const WishlistsType = PropTypes.shape({
    activeTab: PropTypes.number,
    emptyMessage: PropTypes.string,
    items: PropTypes.arrayOf(ItemType),
    totalPages: PropTypes.number,
});

export const WishlistPopupType = PropTypes.shape({
    wishlistsadd: PropTypes.shape({
        title: PropTypes.string,
    }),
});
